module.exports = __webpack_public_path__ + "img/enterprise.92cad5a9.png";